exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Game.Loading {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  width: 100vw;\n  height: 100vh;\n  background: #fff;\n  z-index: 10000; }\n  .Game.Loading .Loading img {\n    width: 300px; }\n  .Game.Loading .Loading-Title {\n    font-size: 1.8rem;\n    margin: 30px 0 30px; }\n  .Game.Loading .Loading-Text {\n    font-size: 1.3rem;\n    font-weight: 200; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Loading/Loading.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/Loading/Loading.css
// module chunks = 0